var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 26.66644,
    viewBox: "0 0 40 26.66644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M39.75858,12.3202C36.01414,4.82392,28.37945.06335,20.00025,0,11.62119.06381,3.98672,4.82425.24193,12.3202c-.32257.63753-.32257,1.3905,0,2.02803,3.74499,7.4955,11.37957,12.25523,19.75832,12.3182,8.37907-.06381,16.01353-4.82424,19.75832-12.3202.3219-.63699.3219-1.38905,0-2.02603ZM20.00025,23.33438c-5.52294,0-10.00016-4.47723-10.00016-10.00016S14.47731,3.33405,20.00025,3.33405s10.00016,4.47723,10.00016,10.00016-4.47723,10.00016-10.00016,10.00016ZM20.00025,6.66811c-.59522.00854-1.18656.09734-1.75803.264,1.08451,1.47988.76399,3.55873-.71589,4.64323-1.16854.85635-2.75728.85669-3.92619.00085-.96208,3.54565,1.13232,7.19989,4.67797,8.16197,3.54565.96208,7.19989-1.13232,8.16197-4.67797.96208-3.54565-1.13232-7.19989-4.67797-8.16197-.57426-.15582-1.16684-.23389-1.76186-.23211v.002Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.856886fe4b7be1c408c94606a813ebed.svg";
export { ForwardRef as ReactComponent };